import {ChangeDetectionStrategy, Component, computed, inject, input, OnInit} from '@angular/core';
import {QuantitySingleGroupComponent} from "./views/quantity-single-group/quantity-single-group.component";
import {LamelareaStore} from "../../../shared/product-card/product-card/lamelarea.store";

import {CuttingOptimizerService} from "./service/cutting-optimizer.service";
import {CuttingPlan} from "./views/cutting-plan/cutting-plan";
import {QuantityCollectiveGroupComponent} from "./views/quantity-collective-group/quantity-collective-group.component";

import {QuantityCalculationService} from "./service/quantity-calculation.service";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-quantity-listing',
  standalone: true,
  imports: [
    QuantitySingleGroupComponent,
    CuttingPlan,
    QuantityCollectiveGroupComponent,
    TranslatePipe
  ],
  templateUrl: './quantity-listing.component.html',
  styleUrls: ['./quantity-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityListingComponent implements OnInit {
  readonly lamellaAreaStore = inject(LamelareaStore);
  private readonly cuttingOptimizerService = inject(CuttingOptimizerService);
  protected quantityCalculationService = inject(QuantityCalculationService);

  readonly tabs = computed(() => {
    return this.type() === 'QUANTITY'
        ? [
          { name: 'Group', value: 'Group' },
          { name: 'Summary', value: 'Summary' },
        ]
        : [
          { name: 'CuttingPlan', value: 'CuttingPlan' },
          { name: 'MountingProfiles', value: 'MountingProfiles' },
        ];
  });

  type  = input<'QUANTITY' | 'CUTTING_PLAN'>('QUANTITY');
  printable = input<boolean>(false);
  protected activeTab: "Group" | "Summary" | "CuttingPlan" | "MountingProfiles";
  protected activeGroupId: string;


  ngOnInit() {
    this.activeTab = this.tabs()[0].value as "Group" | "Summary" | "CuttingPlan" | "MountingProfiles";

    //Set first groupId to activeGroupId
    if (this.type() === 'QUANTITY') {
      this.activeGroupId = this.lamellaAreaStore.lamellaAreaGroups()[0].id;
    }


    const lamellaAreas = this.lamellaAreaStore.getAllLamelareas();
    this.quantityCalculationService.recalculateAll(lamellaAreas, this.cuttingOptimizerService);
  }

  switchTab(tab: "Group" | "Summary" | "CuttingPlan" | "MountingProfiles", groupId?: string) {
    //groupId:tä ei vielä käsitellä sen kummemmpin, voisi olla esim inputti ryhmä täbille
    this.activeTab = tab;

    if(groupId){
      this.activeGroupId = groupId;
    }



  }


}
